import { TopBar } from '@components'
import TabbedLayout from '@components/common/Tab/Tab'
import { FEATURE, ROUTES } from '@constants'
import { useGetFeatures } from '@hooks'
import { SessionProvider } from '@providers'
import { Outlet, useLocation } from 'react-router-dom'

import { LayoutStyle } from './style'
import { hasFeature } from '@helpers/dashboard'

const AuthenticatedLayout = () => {
  const { data: featureList } = useGetFeatures()
  const isEnabled = hasFeature(featureList, FEATURE.ADMIN_DASHBOARD)

  const location = useLocation()
  const locationName = location.pathname.toLocaleLowerCase()
  const dashboardRoute = [ROUTES.DASHBOARD, ROUTES.SUMMARY, ROUTES.ADMIN_DASHBOARD.DASHBOARD, ROUTES.DASHBOARD_UNAVAILABLE]
  const detailRoute = [ROUTES.PLANT_DETAIL, ROUTES.ADMIN_DASHBOARD.DETAIL]
  const showSideBar =
    isEnabled &&
    !Boolean([...dashboardRoute, ...detailRoute].find((route) => route.toLocaleLowerCase() === locationName))
  const isDashboards = Boolean(dashboardRoute.find((route) => route.toLocaleLowerCase() === locationName))

  return (
    <LayoutStyle $isDisplay={true} $isDashboard={isDashboards}>
      {isDashboards ? null : <TopBar />}
      {showSideBar ? (
        <div className='tab'>
          <TabbedLayout />
          <div className='page'>
            <Outlet />
          </div>
        </div>
      ) : (
        <div className='page'>
          <Outlet />
        </div>
      )}
    </LayoutStyle>
  )
}

const Layout = () => {
  return (
    <SessionProvider>
      <AuthenticatedLayout />
    </SessionProvider>
  )
}

export default Layout
